const size = [
    {
        title: "300g",
    },
    {
        title: "400g",
    },
    {
        title: "500g",
    },
    {
        title: "750g",
    },
    {
        title: "1000g",
    },
];

export default size;